import Vue from 'vue'
import VueFullPage from 'vue-fullpage.js'
import App from './App'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue);
Vue.use(VueFullPage);

new Vue({
  el: '#app',
  render: h => h(App),
});